import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Kitchen from 'svg/img/kitchen.jpg';
import Fireplaces from 'svg/img/fireplaces.jpg';
import { portfolioLocations } from 'data/portfolioLocations';

const WhatWeDo = () => {
  const locationCards = [
    {
      ...portfolioLocations[0],
      image: Kitchen,
      cta: 'View projects',
    },
    {
      ...portfolioLocations[1],
      image: Fireplaces,
      cta: 'View projects',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography
              sx={{
                textTransform: 'uppercase',
                fontWeight: 'medium',
              }}
              gutterBottom
              color={'textSecondary'}
              align={'center'}
            >
              Portfolio
            </Typography>
            <Box
              component={Typography}
              fontWeight={700}
              variant={'h3'}
              gutterBottom
              align={'center'}
            >
              Select your location
            </Box>
            <Typography
              variant={'h6'}
              component={'p'}
              color={'textSecondary'}
              align={'center'}
            >
              Choose the region you want to browse. Each portfolio is organized
              around the work we actually do in that area, so you can get to the
              right projects without extra taps.
            </Typography>
          </Grid>
          {locationCards.map((location) => (
            <Grid item xs={12} md={6} key={location.href}>
              <Card
                elevation={0}
                sx={{
                  height: '100%',
                  borderRadius: 3,
                  border: 1,
                  borderColor: 'divider',
                  overflow: 'hidden',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 18px 36px rgba(15, 23, 42, 0.12)',
                  },
                }}
              >
                <Box height={220} bgcolor={'grey.200'} overflow={'hidden'}>
                  <Box
                    component={LazyLoadImage}
                    src={location.image}
                    alt={`${location.title} portfolio preview`}
                    effect={'blur'}
                    width={'100%'}
                    height={'100%'}
                    sx={{
                      display: 'block',
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </Box>
                <CardContent sx={{ padding: 3 }}>
                  <Typography variant={'overline'} color={'primary.main'}>
                    {location.eyebrow}
                  </Typography>
                  <Typography variant={'h4'} gutterBottom sx={{ fontWeight: 700 }}>
                    {location.title}
                  </Typography>
                  <Typography variant={'body1'} color={'textSecondary'}>
                    {location.description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ paddingX: 3, paddingBottom: 3, paddingTop: 0 }}>
                  <Button
                    component={'a'}
                    href={location.href}
                    variant={'contained'}
                    color={'primary'}
                  >
                    {location.cta}
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WhatWeDo;
